import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { PageContentModel } from 'src/app/models/page-content.model';

@Component({
    selector: 'app-dynamic-tab',
    templateUrl: './dynamic-tab.component.html',
    styleUrls: ['./dynamic-tab.component.scss'],
    standalone: false
})
export class DynamicTabComponent implements OnInit {

  @Input() pageContent: PageContentModel
  @Input() active: boolean = false

  @Output() tabClicked: EventEmitter<void> = new EventEmitter()

  title: string

  private currentLang: string

  constructor(public translateService: TranslateService) {
    this.currentLang = translateService.currentLang

    translateService.onLangChange.subscribe(lang => {
      this.setTextByLanguage(lang.lang)
    })}

  ngOnInit(): void {
    this.setTextByLanguage(this.currentLang)
  }

  setTextByLanguage(lang: string){
    if (lang == 'en'){
      this.title = this.pageContent.Title
    } else {
      this.title = this.pageContent.TitleFr
    }
  }

  makeActive(){
    this.tabClicked.emit()
  }


}
